import React from 'react';

import { MessageItem } from './message_item';
import { MessageFromQuery, PhoneWithName } from './types';
import { getPhoneOptionLabel } from './utils';

interface MessageListProps {
  messages: MessageFromQuery[];
  phoneList: PhoneWithName[];
  phoneToFilterBy?: PhoneWithName;
  hasMultiplePhones: boolean;
  onFilterChange: (phone: PhoneWithName | undefined) => void;
  onImageClick: (imageUrl: string) => void;
  onResolveThread: (message: MessageFromQuery) => void;
  loadingState: { resolvingThread: boolean };
}

export const MessageList: React.FC<MessageListProps> = ({
  messages,
  phoneList,
  phoneToFilterBy,
  hasMultiplePhones,
  onFilterChange,
  onImageClick,
  onResolveThread,
  loadingState,
}) => {
  return (
    <div className="messages">
      <h4>
        Message History
        {hasMultiplePhones && (
          <>
            {' for '}
            <select
              value={phoneToFilterBy?.id ? String(phoneToFilterBy.id) : ''}
              onChange={(e) => {
                const value = e.target.value;
                const selected = value ? phoneList.find((phone) => String(phone.id) === value) : undefined;
                onFilterChange(selected);
              }}
            >
              <option value="">All Phones</option>
              {phoneList.map((phone) => (
                <option key={phone.id} value={phone.id}>
                  {getPhoneOptionLabel(phone)}
                </option>
              ))}
            </select>
          </>
        )}
      </h4>

      {messages.length > 0 ? (
        <ul className="list-group">
          {messages.map((message) => (
            <MessageItem
              key={message.id}
              message={message}
              phoneList={phoneList}
              onImageClick={onImageClick}
              onResolveThread={onResolveThread}
              loadingState={loadingState}
            />
          ))}
        </ul>
      ) : (
        <p className="text-muted">No messages found for the selected phone.</p>
      )}
    </div>
  );
};
